import getTargetName from 'services/forms/getTargetName';

import editFieldEventHandler, {
  CHECKBOX_FIELD_EVENT,
  TEXT_FIELD_EVENT,
} from 'services/objects/editFieldEventHandler';
import store from '../../../../../store/store';
import { configurationChanged } from '../../../../../store/configurationChange/actions';
import IWall from '../../../../interfaces/IWall';
import { setWall } from '../../../../../store/selectedWall/actions';
import glassWallPartTypes from '../../../types/glassWallPartTypes';

export const handleGlassWallPropertiesForType = (
  e: any,
  handleType: string,
  targetName?: string
): void => {
  glassWallFieldEventHandler(e, handleType, targetName);
};

const handleGlassWallProperties = (e: any): void => {
  const targetName = getTargetName(e);
  const checkboxFields = [
    'addCornerPlate2k',
    'floorProfileWithColor',
    'hasLock',
    'hasOpenRoof',
    'onlyDoor',
    'showOpenDoors',
    'leftProfileExtraWoody',
    'extraAluminiumProfileFirst',
    'rightProfileExtraWoody',
    'extraAluminiumProfileSecond',
    'hasLeftDoorPrimary',
    'woodyLeftGlassGroove',
    'woodyLeftGuideGroove',
    'woodyLeftBackGroove',
    'woodyRightGlassGroove',
    'woodyRightGuideGroove',
    'woodyRightBackGroove',
    'woodyFloorGlassGroove',
    'woodyFloorGuideGroove',
    'woodyFloorBackGroove',
    'woodyRoofGlassGroove',
    'woodyRoofGuideGroove',
    'woodyRoofBackGroove',
    'woodyIncludeWoodenLists',
    'woodyIncludeWoodyLeftProfile',
    'woodyIncludeWoodyRightProfile',
  ];

  const handleType = checkboxFields.includes(targetName)
    ? CHECKBOX_FIELD_EVENT
    : TEXT_FIELD_EVENT;

  glassWallFieldEventHandler(e, handleType);
};

const glassWallFieldEventHandler = (
  e: any,
  handleType: string,
  targetName?: string
): void => {
  const state = store.getState();

  store.dispatch(configurationChanged());

  const handleWall = editFieldEventHandler(
    state.selectedWall.properties,
    (updatedWall: IWall) =>
      store.dispatch(
        setWall({
          ...updatedWall,
          parts: updatedWall.parts.map((part) => {
            if (part.type === glassWallPartTypes.glass) {
              return part;
            }

            return {
              ...part,
              doorSide: updatedWall.doorSide,
              hasLock: updatedWall.hasLock,
            };
          }),
        })
      ),
    handleType,
    targetName
  );

  handleWall(e);
};

export default handleGlassWallProperties;
